module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wZ01PI/tc-custom/9780830897797.jpg?1685327319564?1696025899343",
      "alt": "This image is the cover for the book The Message of 1 Corinthians, The Bible Speaks Today Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Message of 1 Corinthians, The Bible Speaks Today Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In ancient Greece this phrase was an insult cast at vagrants, drunkards and sexual deviates.  The city of Corinth was infamous as a center of intellectual pride and moral laxity.  Any church planted there was bound to have problems.  The Corinthian church was no exception. Snobbishness, factionalism, insensitivity to other believers, doctrinal lookseness and overexuberance all flourished in the Corinthian church.  When the apostle Paul heard about the difficulties, he was grieved bcause he had founded the church and felt closely tied to it.  He therefore wrote an intense and pointed letter. In this fresh and gripping exposition of 1 Corinthians, David Prior plainly shows the relevance of Paul's letter for our times.  His hope is that all churches may better live out the lordship of Christ in today's cosmopolitan world.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Prior\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("David Prior has pastored churches in Cape Town, South Africa, and Oxford, England, and has served as director of The Centre for Marketplace Theology in London.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Inter-Varsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0